<template lang="pug">
    .profile.container
        .wrapper-form.clearfix
            .form-title
                .text-bold
                    i.fas.fa-edit.u-black-light
                    | Tu perfil
            .form-wrapper
                .form-group
                    label.form-label
                        | Nombre
                    input.form-input(v-model="profile.name")
                .form-group
                    label.form-label
                        |Llavero
                    input.form-input(v-model="profile.wallet", readonly="true")
                .form-group(v-if="isMedic")
                    label.form-label
                        | Especialidad
                    input.form-input(v-model="profile.specliality")
                .clearfix.pt-2
                    input.btn.btn-primary.float-right(type="button", value="Enviar", v-on:click="updateWallet")
</template>


<script>
import gun from '../managers/gun'
// import Gun from 'gun'
// var sea = Gun.SEA
import Swal from 'sweetalert2'
let user = gun.user()
console.log(user)
export default {

    data() {
        return {
            profile: {
                wallet: "",
                speciality: "",
                name: "",
                epub: user._.sea.epub,
                pub: user.is.pub
            },
            masterProfile: null,
            gun: gun
        }
    },
    props: {
        isMedic: Boolean
    },
    methods: {
        updateWallet() {
            console.log(this.profile)
            
   
            user.get("profile").put(this.profile).once(async function () {
                // console.log("pair")
                // console.log(gun.user().is.sea.pair())
                // var data = await sea.sign(this.profile, gun.user()._.sea)
                // console.log(typeof data)
                // gun.get('medic_profiles2').get("aaa").put(data)
                Swal.fire("Perfil actualizado")
                console.log(this)
                gun.get("users").set(this)
            })
            
        }
    },
    created() {
        // console.log("created")
        // gun.get('medic_profiles2').get("aaa").on(data => {
        //     console.log("get wallet")
        //     console.log(data)
        // })
        console.log("usuarios")
        gun.get("usuarios").map().once((i) => {
            console.log("usuario")
            console.log(i)
        })
        // gun.get("medicsKeyring").get(gun.user().is.pub).once((data) => {
        //     console.log(data)
        //     gun.get("~@NodoMaestro").once(nodoMaestro => {
        //         console.log("nodo maestro")
        //         console.log(nodoMaestro)
        //         var epub = nodoMaestro.is.epub
        //         var secret = Gun.SEA.secret(epub, gun.user()._.sea)
        //         var decrypted = Gun.SEA.decrypt(data, secret)
        //         console.log("decrypted")
        //         console.log(decrypted)
        //     })
        // })
        console.log(process.env.VUE_APP_MASTER)
        this.masterProfile = gun.get("~@" + process.env.VUE_APP_MASTER)

        user.get("profile").once((profile) => {
            console.log(profile)

            this.profile = profile || {           }
            this.profile.epub =   gun.user().is.epub
            this.profile.pub = gun.user().is.pub
        })
    }
}
</script>